import type React from "react";
import CustomeButton from "~/components/Button";
import DragAndDropIcon from "../DragAndDropIcon";

export interface DropzoneAreaProps {
  getRootProps: (options?: {
    className?: string;
  }) => React.HTMLAttributes<HTMLElement>;
  getInputProps: () => React.InputHTMLAttributes<HTMLInputElement>;
  isDragActive: boolean;
  open: () => void;
}

const DropzoneArea: React.FC<DropzoneAreaProps> = ({
  getRootProps,
  getInputProps,
  isDragActive,
  open,
}) => (
  <div
    {...getRootProps({
      className: `import-payslip-events__dropzone ${
        isDragActive ? "is-drag-active" : ""
      }`,
    })}
  >
    <input {...getInputProps()} />
    <div className="import-payslip-events__dropzone-icon">
      <DragAndDropIcon />
    </div>
    {isDragActive ? (
      <p className="import-payslip-events__dropzone-text">
        Drop the CSV file here...
      </p>
    ) : (
      <p className="import-payslip-events__dropzone-text">
        Drag & drop CSV file here or click anywhere to choose file.
      </p>
    )}
    <div className="import-payslip-events__dropzone-actions">
      <CustomeButton
        label="Select File"
        variant="outlined"
        icon="pi pi-upload"
        iconPos="right"
        onClick={(e: React.MouseEvent) => {
          e.stopPropagation();
          open();
        }}
      />
    </div>
  </div>
);

export default DropzoneArea;
